<!--
* A checkbox component
*
* @param {string} uncheckedSrc - Image source url for the unchecked image
* @param {string} checkedSrc - Image source url for the checked image
* @param {boolean} isCheckedOnInit - Whether the checkbox should be checked on init
*
* @fires appCheckbox#change
-->

<!--
* @event appCheckbox#change
* @property {boolean} checked  Whether the the checkbox is checked
-->
<!--
  @todo update v-model rather than allowing initial checked state
   and emiting event
-->
<template>
  <!--
    Wrapper div used to stop any instances of parents using flex causing
    sizing issues on checkbox
  -->
  <div>
    <div
      class="ms-checkbox"
      @click="onClick">
      <img
        class="ms-checkbox-image"
        :src="currentSrc">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      selected: {
        required: true,
        type: Boolean
      },
      uncheckedSrc: {
        required: true,
        type: String
      },
      checkedSrc: {
        required: true,
        type: String
      }
    },
    methods: {
      /**
       * Toggle checked and emit change event
       */
      onClick: function () {
        this.$emit('update:selected', !this.selected)
        this.$emit('change', !this.selected)
      }
    },
    computed: {
      /**
       * Gets the current image source
       */
      currentSrc: {
        get () {
          return this.selected ? this.checkedSrc : this.uncheckedSrc
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  .ms-checkbox {
    display: inline-block;
    width: $dims-checkbox-size;
    height: $dims-checkbox-size;
  }

  .ms-checkbox-image {
    width: 100%;
    max-height: 100%;
    height: auto;

    // Needed to stop spacing below image
    display: block;
  }
</style>
